export const storyClasses = {
  content: "story-content",
};
